/**
 *
 * Alerts
 *
 */

import React, { memo, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { Card } from 'components/DataDisplay';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { FindingsIssueContextProvider } from 'containers/Findings/Alerts/Components/AlertsTable/hooks/context';
import { useAlerts } from 'containers/Findings/Alerts/Components/AlertsTable/hooks/useAlerts';
import { OpenAlerts } from 'containers/Findings/Alerts/Components/AlertsTable/OpenAlerts';
import { integrationsSaga } from 'containers/Setup/Integrations/saga';
import * as integrationsSlice from 'containers/Setup/Integrations/slice';
import { actions as sharedStateActions } from 'containers/SharedState/slice';
import { useInjector } from 'utils/inject';

export const Alerts = memo(() => {
  /*Alerts reducer, saga is already injected in App*/
  useInjector(
    integrationsSlice.sliceKey,
    integrationsSlice.reducer,
    integrationsSaga,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sharedStateActions.getAlertResourceTypes({ q: {} }));
    dispatch(sharedStateActions.getAlertCategories({ q: {} }));
  }, [dispatch]);

  return (
    <Card styles={{ card: { h: 'full' } }}>
      <ActiveResourceProvider>
        <FindingsIssueContextProvider value={useAlerts()}>
          <OpenAlerts />
        </FindingsIssueContextProvider>
      </ActiveResourceProvider>
    </Card>
  );
});
